<template>
	<div id="subSuccess">
		<div v-title>申请售后</div>
		<div class="container">
			<div class="img-icon">
				<img src="https://misc.reflower.com.cn/images/customer/icon.png" />
			</div>
			<p class="sub-title">提交成功</p>
			<p class="sub-tip">很抱歉给您带来的困扰，客服MM会在48小时内处理您的售后申请，请您耐心等待~</p>
			<div class="btn-box">
				<div class="btn" @click="goStore">去逛逛商城</div>
				<div class="btn" @click="toApplyList">查看我的售后申请</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {

			}
		},
		craeted() {

		},
		mounted() {
			let h = document.documentElement.clientHeight || document.body.clientHeight;
			let container = document.getElementById("subSuccess");
			container.style.height = h + 'px'
		},
		methods: {
			toApplyList : function(){
				this.$router.push({
					path : '/'
				})
			},
			
			goStore : function(){
				window.location.href="https://m.reflower.com.cn/";
			}
		}
	}
</script>

<style scoped>
	#subSuccess{
		background-color: #FFFFFF;
	}
	.container{
		padding-top: 3.84rem;
	}
	
	.container .img-icon{
		width: 100%;
		height: 1.6rem;
		/*margin: 3.84rem auto 0 auto;*/
	}
	
	.container .img-icon img{
		width: 3.733333rem;
		height: 1.6rem;
	}
	.container .sub-title{
		font-size: 0.48rem;
		color: #666666;
		margin-bottom: 0.373333rem;
	}
	.container .sub-tip{
		font-size: 0.373333rem;
		color: #999999;
		padding: 0 1.52rem;
		line-height: 0.533333rem;
	}
	
	.btn-box{
		width: 100%;
		display: flex;
		justify-content: space-between;
		padding: 0 0.8rem;
		margin-top: 0.56rem;
	}
	.btn-box .btn{
		font-size: 0.4rem;
		color: #C8D678;
		width: 4rem;
		height: 0.933333rem;
		line-height: 0.933333rem;
		border: 1px solid #C8D678;
		border-radius: 0.08rem;
		
	}
</style>


// WEBPACK FOOTER //
// src/path/subSuccess.vue